import { IonApp, IonRouterOutlet, setupIonicReact } from '@ionic/react';
import {Route, Routes, Navigate, BrowserRouter} from 'react-router-dom';

import Login from './pages/Login';

/* Core CSS required for Ionic components */
import '@ionic/react/css/core.css';
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Tailwind */
import './index.css';
import {ProtectedRoute} from "@/components/layout/ProtectedRoute";
import Dashboard from "@/pages/Dashboard";
import {ReactQueryDevtools} from "@tanstack/react-query-devtools";
import {QueryClientProvider} from "@tanstack/react-query";
import {queryClient} from "@/config/queryClient";

setupIonicReact();

const App = () => (
    <QueryClientProvider client={queryClient}>
        <IonApp>
            <BrowserRouter>
                <IonRouterOutlet>
                    <Routes>
                        <Route path="/login" element={<Login/>}/>
                        <Route
                            path="/dashboard"
                            element={
                                <ProtectedRoute>
                                    <Dashboard/>
                                </ProtectedRoute>
                            }
                        />
                        <Route path="/" element={<Navigate to="/login" replace/>}/>
                    </Routes>
                </IonRouterOutlet>
            </BrowserRouter>
        </IonApp>

        {/* DevTools en dev only */}
        {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false}/>}
    </QueryClientProvider>
);

export default App;